import React from 'react'
import PropTypes from 'prop-types'
import {useTranslation, Trans} from 'react-i18next'
import {Flex, chakra, Button} from '@chakra-ui/react'
import {Alert} from '~/react/components'

export const NoActivePaymentMethod = ({isProcessingPaymentMethod}) => {
  const {t} = useTranslation('pointsOnPayments')

  return (
    <Alert
      status="warning"
      title={t(
        'pointsOnPayments:paymentMethods.generic.instructions.none.title',
      )}
      message={
        <Flex direction="column" gap="xs" align="flex-start">
          <Trans
            t={t}
            i18nKey={`pointsOnPayments:paymentMethods.generic.statusDescription.${
              isProcessingPaymentMethod ? 'processing' : 'none'
            }`}
            components={{
              span: <chakra.span fontSize="sm" />,
            }}
          />
          {!isProcessingPaymentMethod && (
            <Button
              as="a"
              href="/settings/payment_methods"
              variant="secondary"
              role="button"
              name={t('pointsOnPayments:bill.tabs.payBills.callToAction')}
              sx={{backgroundColor: 'transparent'}}
            >
              {t(
                'pointsOnPayments:paymentMethods.generic.instructions.none.callToAction',
              )}
            </Button>
          )}
        </Flex>
      }
    />
  )
}

NoActivePaymentMethod.propTypes = {
  isProcessingPaymentMethod: PropTypes.bool,
}

NoActivePaymentMethod.defaultProps = {
  isProcessingPaymentMethod: false,
}

export default NoActivePaymentMethod
